export function parseYouTubeId(input: string): string | null {
  const trimmed = input.trim();
  if (/^[A-Za-z0-9_-]{11}$/.test(trimmed)) return trimmed;
  const match = trimmed.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|live\/|embed\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i,
  );
  return match?.[1] ?? null;
}

const LEVEL_COUNT_DEFAULT: Record<1 | 2 | 3, number> = { 1: 5, 2: 8, 3: 6 };

/** Parse the `?counts=5,8,6` query value ("l1,l2,l3") into typed counts. */
export function parseCountsParam(value: string | null): Record<1 | 2 | 3, number> | null {
  if (!value) return null;
  const parts = value.split(",").map((s) => Number.parseInt(s.trim(), 10));
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) return null;
  return { 1: parts[0]!, 2: parts[1]!, 3: parts[2]! };
}

export function defaultsForCounts(value: string | null): Record<1 | 2 | 3, number> {
  return parseCountsParam(value) ?? LEVEL_COUNT_DEFAULT;
}

export function toEmbedUrl(videoId: string): string {
  return `https://www.youtube-nocookie.com/embed/${videoId}?playsinline=1&rel=0`;
}

export function toWatchUrl(videoId: string): string {
  return `https://youtu.be/${videoId}`;
}